import { render, staticRenderFns } from "./ProductionCard.vue?vue&type=template&id=0ff3dd4f&scoped=true"
import script from "./ProductionCard.vue?vue&type=script&lang=js"
export * from "./ProductionCard.vue?vue&type=script&lang=js"
import style0 from "./ProductionCard.vue?vue&type=style&index=0&id=0ff3dd4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3dd4f",
  null
  
)

export default component.exports